import { Modal as AntdModal, type ModalProps as AntdModalProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

export type ModalProps = {
    children: JSX.Element;
    closable?: boolean;
} & Omit<AntdModalProps, 'closable'>;

const StyledModal = styled(AntdModal)`
    & .ant-modal-title {
        font-size: 18px;
    }

    & .ant-modal-footer {
        display: flex;
        justify-content: flex-end;
    }

    & .ant-modal-footer > button {
        font-size: 16px;
        min-width: 100px;
        height: 48px;
    }

    & p-button:last-child {
        margin-left: 8px;
    }
`;

const Modal = ({ children, closable = false, ...props }: ModalProps) => (
    <StyledModal closable={closable} maskClosable={props.maskClosable || false} {...props}>
        {children}
    </StyledModal>
);

export default Modal;
